export const categoryList = [
  {
    key: "",
    value: "All",
  },
  {
    key: "webinar",
    value: "Webinars",
  },
  {
    key: "virtual-event",
    value: "Virtual Events",
  },
  {
    key: "videos-and-presentations",
    value: "Videos and Presentations",
  },
  {
    key: "articles-and-blogs",
    value: "Articles and Blogs",
  },
];
